import { Grid, Link, makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ProfilePicture from 'components/common/ProfilePicture'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import PatientStatus from 'components/Patients/PatientStatus'
import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import { ROUTES } from 'consts'
import { trackEvent } from 'utils/analyticsUtils'

const useStyles = makeStyles(() => ({
  row: { padding: 20, borderBottom: '1px solid #E9E9E9', minHeight: 90 },
  details: { marginLeft: 10, minWidth: 0, flex: 1 },
  name: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  link: { color: 'var(--text-color-25)', marginLeft: 20, fontSize: 14 }
}))

const MissingCopilotSettingsListItem = ({ patient }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { getPatientStatusObject } = useCopilotPatientsList()
  const patientId = patient.patientId

  return (
    <Grid container alignItems="center" wrap="nowrap" className={classes.row}>
      <ProfilePicture name={patient.name} photo={patient.profilePicture} />
      <Grid item className={classes.details}>
        <DazzedParagraph14 className={classes.name}>{patient.name}</DazzedParagraph14>
        <PatientStatus status={getPatientStatusObject(patient.statusKey, patient.program)} />
      </Grid>
      {patientId && (
        <Link
          className={classes.link}
          underline="always"
          href={`${ROUTES.PATIENTS}/${patientId}?patientView=copilot`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            trackEvent('Copilot Control - Patient opened from list', { view: 'Missing Copilot Settings', patientId })
          }
        >
          {t('pages.copilotControl.mainPage.copilotUtilization.patientSettings')}
        </Link>
      )}
    </Grid>
  )
}

export default MissingCopilotSettingsListItem
